import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import RecordHero from './components/RecordHero';
import RecordTable from './components/RecordTable';

const RecordPage = () => {
  usePageMeta({
    title: '開発実績 | 株式会社MSK',
    ogTitle: '開発実績 | 株式会社MSK',
    description: '株式会社MSKのこれまでの開発実績をご紹介いたします。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <RecordHero />
        <RecordTable />
      </main>
      <Footer />
    </div>
  );
};

export default RecordPage;